module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEKSURBVHgBrVSBDYIwEGyJA7ABbCAbyAgwgd1EnEQ3wA1gA3EC2MAR8D48oZZviYZPLjz31+uXlmrliXEcUzxyIGWqI2itB0kfCQY50CB9AierdAYaqvEk/oDgArwBE9AYoCdtyKTfnG3SpqKZVdg0ccZQ97lNNvZykMeSKQ+OrXfD33PpxtNhZnGZ1DV3lVBSAA9h9nlgZueC7k6dHZBTsXMFOC8dBCXSmqmSOLWOAUgjtVNE7Ji4BV4GdVMyamlpiKOiFc3b6Jj88rEXbpftZyLnbVwN9oX3EIOo/vhFKp9gNjMBE8Pdf5loaTY8bmq6h+jcvLhEO1swd8WZaoNGjmHGoBiA1nexfQAsCk/y9r8NtgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/audio/btn_mobile_player_close.png
// module id = DTZX
// module chunks = 1